/**
 * Typed access to Vite env. All runtime config lives in .env files.
 */

const raw = import.meta.env as Record<string, string | undefined>;

function str(key: string, fallback = ''): string {
  const v = raw[key];
  return v == null || v === '' ? fallback : v;
}

export interface AppEnv {
  /** Axios base URL (absolute or same-origin proxy path). */
  authApiUrl: string;
  /** Portal application name for unified login (JWT aud). */
  portalAppName: string;
  devextremeLicenseKey: string;
  isDev: boolean;
  isProd: boolean;
}

export const env: AppEnv = {
  authApiUrl:
    !!import.meta.env.DEV && raw.VITE_PROXY_AUTH_TARGET
      ? '/api'
      : str('VITE_AUTH_API_URL', 'http://localhost:8102'),
  portalAppName: str('VITE_PORTAL_APP_NAME', 'botto-auth'),
  devextremeLicenseKey: str('VITE_DEVEXTREME_LICENSE_KEY', ''),
  isDev: !!import.meta.env.DEV,
  isProd: !!import.meta.env.PROD,
};
